import { render, staticRenderFns } from "./custom.vue?vue&type=template&id=2ecd7054&scoped=true"
import script from "./custom.vue?vue&type=script&lang=js"
export * from "./custom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecd7054",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ecd7054')) {
      api.createRecord('2ecd7054', component.options)
    } else {
      api.reload('2ecd7054', component.options)
    }
    module.hot.accept("./custom.vue?vue&type=template&id=2ecd7054&scoped=true", function () {
      api.rerender('2ecd7054', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/user/account/custom.vue"
export default component.exports